import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fordable" }
const _hoisted_2 = { class: "common_table custom_scroll" }
const _hoisted_3 = { class: "cnt" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list_num" }
const _hoisted_7 = { class: "cnt" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "cnt checkbox_wrap _plus" }
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "value", "checked", "onClick"]
const _hoisted_13 = { class: "cnt" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", null, [
          _cache[6] || (_cache[6] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { style: {"width":"60px"} }),
            _createElementVNode("col", { style: {"width":"70px"} }),
            _createElementVNode("col", { style: {"width":"210px"} }),
            _createElementVNode("col"),
            _createElementVNode("col", { style: {"width":"120px"} }),
            _createElementVNode("col", { style: {"width":"80px"} }),
            _createElementVNode("col", { style: {"width":"80px"} }),
            _createElementVNode("col", { style: {"width":"80px"} })
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "순서"),
              _createElementVNode("th", null, "번호"),
              _createElementVNode("th", null, "게시판 이름"),
              _createElementVNode("th", null, "제목"),
              _createElementVNode("th", null, "조회수"),
              _createElementVNode("th", null, "이미지"),
              _createElementVNode("th", null, "메인노출"),
              _createElementVNode("th", null, "삭제")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            ($setup.listState.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.listState.list, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.idx
                  }, [
                    _createElementVNode("td", _hoisted_3, [
                      (item.isMain === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "move_up _sub",
                              onClick: ($event: any) => ($setup.changeOrder(item, 0))
                            }, [...(_cache[1] || (_cache[1] = [
                              _createElementVNode("img", {
                                src: "img/up_icon.png",
                                alt: ""
                              }, null, -1)
                            ]))], 8, _hoisted_4),
                            _createElementVNode("button", {
                              type: "button",
                              class: "move_down _sub",
                              onClick: ($event: any) => ($setup.changeOrder(item, 1))
                            }, [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("img", {
                                src: "img/down_icon.png",
                                alt: ""
                              }, null, -1)
                            ]))], 8, _hoisted_5)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(($setup.listState.page - 1) * $setup.listState.size + (idx + 1)), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "감시소식", -1)),
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1),
                    _createElementVNode("td", _hoisted_7, [
                      (item.thumbnail)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tb_img img_wrap",
                            onClick: ($event: any) => ($setup.viewImage(item.thumbnail))
                          }, [
                            _createElementVNode("img", {
                              style: {"max-width":"100%"},
                              src: item.thumbnail,
                              alt: ""
                            }, null, 8, _hoisted_9)
                          ], 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("label", {
                        for: 'chk_gamsi_' + item.idx,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("input", {
                          id: 'chk_gamsi_' + item.idx,
                          type: "checkbox",
                          value: item.idx,
                          checked: item.isMain === 1,
                          onClick: ($event: any) => ($setup.isMain(item.idx, 3))
                        }, null, 8, _hoisted_12),
                        _cache[3] || (_cache[3] = _createElementVNode("em", null, null, -1))
                      ], 8, _hoisted_11)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "table_btn _gray",
                        onClick: ($event: any) => ($setup.confirmForDelete(item.idx))
                      }, "삭제", 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("td", { colspan: "8" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "데이터가 없습니다.")
                  ], -1)
                ]))]))
          ])
        ])
      ]),
      ($setup.listState.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.listState.page,
            totalLength: $setup.listState.totalLength,
            perPage: $setup.listState.size,
            onOnPaging: $setup.handlePage
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}